module.exports = __webpack_public_path__ + "static/media/couverture-my-dear-vagina.412c100e.jpg";